<template>
	<div class="row">
		<div class="col col-md-2 col-sm-3">
			<PopularStock @p_show_kline="show_kline"></PopularStock>
		</div>
		<div class="col col-md-10 col-sm-9">
			<!-- <StockKlineWithPopular  :symbol_code="symbol_code"  :title="symbol_code" :subText="symbol_name"></StockKlineWithPopular> -->
			<StockMultiChart  :symbol_code="symbol_code"  :symbol_name="symbol_name" :chart_width="'1000px'"></StockMultiChart>
			<div role="group">
				<label for="input-live">股票代码:</label>
					<b-form-input
					id="input-symbol_code"
					v-model="symbol_code"
					:state="nameState"
					aria-describedby="input-live-help input-live-feedback"
					placeholder="6位股票代码"
					trim
					style="width: 200px;"></b-form-input>
					<!-- This will only be shown if the preceding input has an invalid state -->
					<b-form-invalid-feedback id="input-live-feedback">
						请输入6位股票代码
					</b-form-invalid-feedback>
					<!-- This is a form text block (formerly known as help block) -->
					<!-- <b-form-text id="input-live-help">输入6位股票代码,自动切换图形</b-form-text> -->
			</div>
		</div>
	</div>
</template>

<script>
	import PopularStock from 'components/sentiment/PopularStock.vue'
	// import StockKlineWithPopular from 'components/stock/StockKlineWithPopular.vue'
	import StockMultiChart from 'components/stock/StockMultiChart.vue'
	import Moment from 'moment'
	import {request_zzquant} from "network/request.js"
	
	export default {
		data() {
			return {
				symbol_name:"",
				symbol_code:"600196",
				isBusy: true,
				fields: [
					{
						key: 'rank',
						sortable: true
					},
					{
						key: 'rank_diff',
						label: 'diff',
						sortable: true,
						
					},
					{
						key: 'symbol_name',
						label: 'symbol',
						sortable: true,
						// formatter: (value, key, item) => {
						// 	return value + item.symbol_code
						// }
					},{
						key:'last_pct',
						sortable: true,
						// formatter: (value) => {
						// 	return '<span style="'+this.getPercentColor(value)+'">'+value+'</span>'
						// }
					}
				],
				items: []
			}
		},
		computed:{
			nameState() {
				if (this.symbol_code.length == 6){
					return true
				}
				return false
			}
		},
		components: {
			PopularStock,
			// StockKlineWithPopular,
			StockMultiChart,
		},
		mounted() {
			this.load_popular_data();
		},
		methods:{
			show_kline(symbol_code){
				this.symbol_code = symbol_code
				// console.log(symbol_code)
			},
			rowClass(item,type){
				if (!item || type !== 'row') return
				// if (item.last_pct >0) return 'table-danger'
				return this.getPercentStyle(item.last_pct)
			},
			load_popular_data(){
				let url = 'open/sentiment/media/ths2/top?date1='+Moment().format("YYYY-MM-DD")+'&top_n=100'
				request_zzquant({
					'url': url
				}).then((resp1) => {
					// console.log(resp1);
					this.items = resp1.data.data
					this.isBusy = false
				}).catch(err => {
					console.log(err);
				})
			},
			getGradientColor(start_color, end_color, percent) {
				// strip the leading # if it's there
				start_color = start_color.replace(/^\s*#|\s*$/g, '');
				end_color = end_color.replace(/^\s*#|\s*$/g, '');
			
				// convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
				if (start_color.length == 3) {
					start_color = start_color.replace(/(.)/g, '$1$1');
				}
			
				if (end_color.length == 3) {
					end_color = end_color.replace(/(.)/g, '$1$1');
				}
			
				// get colors
				function parse(rgb, i) {
					return parseInt(rgb.substr(i, 2), 16)
				}
			
				let start_r = parse(start_color, 0),
					start_g = parse(start_color, 2),
					start_b = parse(start_color, 4);
			
				let end_r = parse(end_color, 0),
					end_g = parse(end_color, 2),
					end_b = parse(end_color, 4);
			
				// calculate new color
				let r = end_r - start_r;
				let g = end_g - start_g;
				let b = end_b - start_b;
			
				r = ((r * percent) + start_r)
				g = ((g * percent) + start_g)
				b = ((b * percent) + start_b)
			
				function hex(x) {
					let h = x.toString(16).split('.')[0].toUpperCase()
					return (h.length == 1) ? '0' + h : h
				}
			
				return '#' + hex(r) + hex(g) + hex(b)
			},
			
			getPercentColor(pt) {
				if (pt >= 0) {
					if (pt > +10) {
						pt = +10;
					}
					pt = +pt / 10;
					return this.getGradientColor('#FFFFFF', '#FB1023', pt)
				} else {
					if (pt < -10) {
						pt = -10;
					}
					pt = -pt / 10;
					return this.getGradientColor('#FFFFFF', '#278B22', pt)
				}
			},getPercentStyle(pt) {
				return {
					'background': this.getPercentColor(pt)
				}
			},
		}
	}
</script>

<style scoped>

</style>
